import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { BannerComponent } from '../components/banner/banner.component';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  banners = new BehaviorSubject<BannerComponent[]>([]);
  banners$ = this.banners.asObservable();
  componentRefs: ComponentRef<BannerComponent>[] = [];
  targetElement: HTMLElement;

  constructor() { }

  loadComponent(container: ViewContainerRef, options: any) {
    const { text, type, size, canClose, id } = options;
    const component = container.createComponent(BannerComponent);

    component.instance.text = text;
    component.instance.type = type;
    component.instance.size = size;
    component.instance.canClose = canClose;
    component.instance.id = id;
    component.instance.closeBanner = () => {
      this.destroyComponent(component.instance);
    };

    this.componentRefs.push(component);
    this.addBanner(options);
  }

  destroyComponent(config: any) {
    const index = this.componentRefs.findIndex(cr => cr.instance.id === config.id);

    if (index !== -1) {
      this.componentRefs[index].destroy();
      this.componentRefs.splice(index, 1);
      this.removeBanner(config);
    }
  }

  addBanner(banner: BannerComponent): void {
    const currentBanners = this.banners.getValue();
    const updatedBanners = [...currentBanners, banner];
    this.banners.next(updatedBanners);
  }

  removeBanner(banner: BannerComponent): void {
    const currentBanners = this.banners.getValue();
    const updatedBanners = currentBanners.filter(item => item.id !== banner.id);
    this.banners.next(updatedBanners);
  }

  clearBanners(): void {
    this.componentRefs.forEach(ref => ref.destroy());
    this.componentRefs = [];
    this.banners.next([]);
  }
}
